import { yupHelper } from "lib/helpers";
import uriSchema from "./schema";

const { handlePromiseError, validateValue } = yupHelper;

const validate = async (field, value, cms) => {
  let promise = "";
  switch (field) {
    case "uri":
      promise = validateValue(uriSchema(cms), { URI: value });
      break;
    default:
      return "";
  }
  return handlePromiseError(promise);
};

export default validate;
